export default function UserSquareIcon() {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_920_6844)">
        <path
          d="M92.5713 72V85.7143C92.5713 87.5329 91.8489 89.2771 90.5629 90.563C89.2769 91.849 87.5328 92.5714 85.7142 92.5714H71.9999M71.9999 3.42859H85.7142C87.5328 3.42859 89.2769 4.15104 90.5629 5.437C91.8489 6.72296 92.5713 8.4671 92.5713 10.2857V24M3.42847 24V10.2857C3.42847 8.4671 4.15091 6.72296 5.43688 5.437C6.72284 4.15104 8.46698 3.42859 10.2856 3.42859H23.9999M23.9999 92.5714H10.2856C8.46698 92.5714 6.72284 91.849 5.43688 90.563C4.15091 89.2771 3.42847 87.5329 3.42847 85.7143V72"
          stroke="url(#paint0_linear_920_6844)"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.9999 44.5715C55.5741 44.5715 61.7142 38.4314 61.7142 30.8572C61.7142 23.283 55.5741 17.1429 47.9999 17.1429C40.4257 17.1429 34.2856 23.283 34.2856 30.8572C34.2856 38.4314 40.4257 44.5715 47.9999 44.5715Z"
          stroke="white"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M69.6684 72C67.7185 67.9051 64.6481 64.4466 60.813 62.0252C56.978 59.6038 52.5354 58.3186 47.9999 58.3186C43.4644 58.3186 39.0217 59.6038 35.1867 62.0252C31.3517 64.4466 28.2813 67.9051 26.3313 72"
          stroke="white"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_920_6844"
          x1="3.46595"
          y1="48.2882"
          x2="92.5812"
          y2="48.2882"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
        <clipPath id="clip0_920_6844">
          <rect width="96" height="96" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
